<template>
  <el-dialog
    :title="$t('view_god_set_index_224')"
    :visible.sync="showtag"
    class="god_set"
    width="600"
    v-dialogDrag
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closed"
    v-loading="loading"
  >
  <div class="god_set_frame">
    <div>
      <el-input :placeholder="$t('view_god_set_index_225')" v-model="del_id" style="width:380px"></el-input>
      <el-button type="primary" @click="del">{{$t('view_god_set_index_226')}}</el-button>
    </div>

    <el-button type="primary" @click="add_page_modules">{{$t('view_god_set_index_227')}}</el-button>
      



  </div>
  </el-dialog>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

export default {
  name: "god_set",
  data() {
    return {
      showtag: true,
      loading:false,
      del_id:''

    };
  },
  props: {
    module: {
      type: Object,
      default: null
    }
  },
  methods: {
      closed(){
          this.showtag = true;
          this.$emit('closed')
      },
      del(){
        if(this.del_id == ''){
          return
        }
        const r = this.templet.find_obj(this.del_id);
        this.$store.state.myRender[r.rowType].splice(r.row_index,1);

      },
      add_page_modules(){
        this.templet.is_add_page_modules();
      }

  },
  computed: {},
  created() {},
  mounted() {},
  components: {}
};
</script>

<style lang="scss" scoped>
.god_set{
  /deep/ .el-dialog{
    width: 500px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/god_set/index.vue